import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';
import './NewsPage.css';

const fmtDate = d => d ? new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

const NewsPage = () => {
    const [site, setSite] = useState(null);
    const [newsMeta, setNewsMeta] = useState(null);
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get('/content/site'),
            api.get('/content/news'),
            api.get('/news?limit=50'),
        ])
            .then(([siteRes, metaRes, newsRes]) => {
                setSite(siteRes.data);
                setNewsMeta(metaRes.data);
                setArticles(newsRes.data.articles || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error loading news:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!site) {
        return (
            <div className="error-screen">
                <h1>Error loading content</h1>
                <p>Please try again later.</p>
            </div>
        );
    }

    return (
        <div className="App">
            <MetaTags
                title="News | Melbourne Nepalese Community West"
                description="Stay updated with the latest news, announcements, and stories from Melbourne Nepalese Community West (MNCW)."
                url="https://mncw.org.au/news"
                image="https://mncw.org.au/assets/img/logo.jpg"
                type="website"
            />
            <Header data={site} />
            <div className="news-page-container">
                <div className="container">
                    <div className="page-header">
                        <h1>{newsMeta?.title}</h1>
                        <p className="page-intro">{newsMeta?.intro}</p>
                    </div>

                    <div className="news-grid">
                        {articles.map((item) => (
                            <div key={item.slug || item.id} className="news-card">
                                <div className="news-image">
                                    {item.image_url && <img src={item.image_url} alt={item.title} />}
                                    <span className="news-label">
                                        {item.category}
                                    </span>
                                </div>
                                <div className="news-content">
                                    <div className="news-date">
                                        <i className="fas fa-calendar-alt"></i>
                                        {fmtDate(item.published_at)}
                                    </div>
                                    <h3>{item.title}</h3>
                                    <p>{item.excerpt}</p>
                                    <Link to={`/news/${item.slug || item.id}`} className="news-link">
                                        Read More <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer data={site} />
        </div>
    );
};

export default NewsPage;
